import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './overwatch-theme.css'; // Import Overwatch theme styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Import i18n configuration
import { initMatomo } from './utils/matomoTracker'; // Import Matomo tracking utility

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Initialize Matomo tracking (loads without cookies until user consents)
initMatomo().then(() => {
  // If user already accepted cookies in a previous session, grant consent now
  const cookieChoice = localStorage.getItem('cookieConsent');
  if (cookieChoice === 'accepted') {
    const { grantCookieConsent } = require('./utils/matomoTracker');
    grantCookieConsent();
  }
}).catch(error => {
  console.error('Failed to initialize Matomo:', error);
});
